export default __webpack_public_path__ + "static/media/center01.9cfabfc6.jpg";